import { BORDER_STYLE_PRIMARY } from '@/features/mold/components';
import type { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const ReportTable: FC<Props> = ({ children }) => (
  <table
    style={{
      borderCollapse: 'collapse',
      height: '100%',
      border: BORDER_STYLE_PRIMARY,
    }}
  >
    {children}
  </table>
);
